var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.horizontal)?_c('div',{staticClass:"horizontal"},[_c('div',_vm._b({},'div',_vm.$attrs,false),[_vm._t("default")],2)]):_c('div',_vm._g({staticClass:"scrollable",class:{'no-overflow': _vm.noOverflow },on:{"scroll":_vm.onScroll}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }